import { motion } from "framer-motion";
import { Bot } from "lucide-react";

export function LoadingMessage() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.95 }}
      className="flex gap-2 p-3 rounded-lg bg-muted/50 items-center max-w-[85%] md:max-w-[75%]"
    >
      <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center ring-1 ring-primary/20">
        <Bot className="h-3 w-3 text-primary" />
      </div>
      <div className="flex gap-1">
        <div className="h-1.5 w-1.5 rounded-full bg-primary/40 animate-bounce" style={{ animationDelay: "0ms" }} />
        <div className="h-1.5 w-1.5 rounded-full bg-primary/40 animate-bounce" style={{ animationDelay: "150ms" }} />
        <div className="h-1.5 w-1.5 rounded-full bg-primary/40 animate-bounce" style={{ animationDelay: "300ms" }} />
      </div>
    </motion.div>
  );
}